import { render, staticRenderFns } from "./SDD_Blacklist.vue?vue&type=template&id=57791338&scoped=true&"
import script from "./SDD_Blacklist.vue?vue&type=script&lang=js&"
export * from "./SDD_Blacklist.vue?vue&type=script&lang=js&"
import style0 from "./SDD_Blacklist.vue?vue&type=style&index=0&id=57791338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57791338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57791338')) {
      api.createRecord('57791338', component.options)
    } else {
      api.reload('57791338', component.options)
    }
    module.hot.accept("./SDD_Blacklist.vue?vue&type=template&id=57791338&scoped=true&", function () {
      api.rerender('57791338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/SDD_Blacklist.vue"
export default component.exports